(function () {
  'use strict';
  class Controller {}
  angular
    .module('actions')
    .component('authLoginAction', {
      controller: Controller,
      templateUrl: 'actions/auth/login/login-auth.action.html',
      bindings: {
        credentials: '<',
        then: '&',
        catch: '&'
      }
    });
}());
